import { 
  SET_NOTIFICATIONS_VIEW, 
  SET_NOTIFICATIONS_NOT_VIEW,
  UPDATE_NOTIFICATIONS_NOT_VIEW,
  UPDATE_NOTIFICATIONS_VIEW,
  SET_NOTIFICATIONS_TO_READ,
  UPDATE_NOTIFICATIONS_LIST_VIEW,
  SET_NEW_NOTIFICATION,
} from './types'

const notificationsState = {
    view: [],
    not_view: [],
    view_settings: {
      limit: 10,
      page: 1,
      nextPage: null
    },
    not_view_settings: {
      limit: 10,
      page: 1,
      nextPage: null
    }
}

const updateList = (old, list) => {

  const result = [ ...old, ...list ]

  let filter = result.filter((cur, i, a)=> a.findIndex(item => (item._id === cur._id) ) === i)

  return filter

}

const removeNotificationAndUpdateNotView = (notViewList, viewList) => {


  let notificationsNotRead = notViewList.filter(data => data.view)

  let notificationsRead = [ ...notificationsNotRead, ...viewList]

  let updatedNotifications = notViewList.filter(item => !notificationsNotRead.includes(item))

  return {
    view: notificationsRead,
    not_view: updatedNotifications
  }

}

const updateNotificationList = (id, notViewList) => {

  let copy = [ ...notViewList ]

  return copy.map(data => {

    if (data._id === id) {

      return {
        ...data,
        view: true
      }

    }

    return data

  })

}

const updateNewNotificationList = (item, oldList) => {

  let copy = [ item, ...oldList ]

  let filter = copy.filter((cur, i, a)=> a.findIndex(item => (item._id === cur._id) ) === i)

  return filter

}

const notificationsReducer = (state, actions) => {

    const { type, payload } = actions

    switch (type) {

        case SET_NOTIFICATIONS_VIEW: {
          return {
              ...state,
              view: payload.notifications,
              view_settings: {
                ...state.view_settings,
                page: payload.page,
                nextPage: payload.nextPage
              }
          }
        }

        case SET_NOTIFICATIONS_NOT_VIEW: {
          return {
            ...state,
            not_view: payload.notifications,
            not_view_settings: {
              ...state.not_view_settings,
              page: payload.page,
              nextPage: payload.nextPage
            }
          }
        }

        case UPDATE_NOTIFICATIONS_VIEW: {
          return {
            ...state,
            view: updateList(state.view, payload.notifications),
            view_settings: {
              ...state.view_settings,
              page: payload.page,
              nextPage: payload.nextPage
            }
          }
        }

        case UPDATE_NOTIFICATIONS_NOT_VIEW: {
          return {
            ...state,
            not_view: updateList(state.not_view, payload.notifications),
            not_view_settings: {
              ...state.not_view_settings,
              page: payload.page,
              nextPage: payload.nextPage
            }
          }
        }

        case UPDATE_NOTIFICATIONS_LIST_VIEW: {
          return {
            ...state,
            not_view: updateNotificationList(payload, state.not_view)
          }
        }

        case SET_NOTIFICATIONS_TO_READ: {
          return {
            ...state,
            ...removeNotificationAndUpdateNotView(state.not_view, state.view)
          }
        }

        case SET_NEW_NOTIFICATION: {

          return {
            ...state,
            not_view: updateNewNotificationList(payload, state.not_view)
          }

        }

        default: {
          return state
        }

    }

}

export { notificationsReducer as default, notificationsState }